import React from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './CustomButton.module.css';

function CustomButton(props) {
    const { id, style, variant, label, icon, border, onClick, enabled = true, rounded = false, outlined = false, loading = false, ...otherProps } = props;

    // Handle custom styles
    let customStyles = {};
    if (border) {
        customStyles.borderWidth = border;
    }

    // For secondary style, we need to apply custom styling
    if (style == "secondary" && !rounded) {
        if (variant == "contained") {
            customStyles.backgroundColor = "var(--color-secondary)";
            customStyles.color = "#fff";
        } else if (variant == "outlined") {
            customStyles.color = "var(--color-secondary)";
            customStyles.borderColor = "var(--color-secondary-light)";
        }
    }

    // Map our style prop to MUI color prop
    const getColor = (style) => {
        // For secondary style, we'll handle it with custom styling
        if (style == "secondary") return "primary"; // Use primary as base
        
        switch (style) {
            case "primary": return "primary";
            case "tertiary": return "info"; // Use info instead of tertiary which is not a valid MUI color
            case "warning": return "warning";
            case "error": return "error";
            default: return "primary";
        }
    };

    // Handle CSS classes
    let cssClasses = otherProps.className || '';
    if (rounded) {
        if (outlined) {
            cssClasses += ` ${styles.outlinedRoundedButton} ${styles[`outlined${style.charAt(0).toUpperCase() + style.slice(1)}`]}`;
        } else {
            cssClasses += ` ${styles.roundedButton} ${styles[style]}`;
        }
    }
    
    // Add disabled class when button is not enabled
    if (!enabled) {
        cssClasses += ` ${styles.disabled}`;
    }

    function OnClickHandler(event) {
        if (onClick) {
            onClick(event, id);
        }
    }

    const buttonProps = {
        variant: rounded ? (outlined ? 'outlined' : 'contained') : variant,
        color: getColor(style),
        onClick: OnClickHandler,
        disableElevation: true,
        disabled: !enabled,
        style: customStyles,
        className: cssClasses,
        ...otherProps
    };

    if (!label || label == "") {
        return (
            <Button {...buttonProps}>
                {icon}
            </Button>
        );
    }

    return (
        <Button {...buttonProps} startIcon={!loading && icon}>
            {loading ? (
                <CircularProgress size={24} color="inherit" sx={{ mr: label ? 1 : 0 }} />
            ) : null}
            {label}
        </Button>
    );
}

export default CustomButton;
